/* Header behaviours: sticky on scroll-up, hover/click dropdowns, mobile drawer <dialog>. No dependencies. */
(function () {
function initHeader(header) {
  if (!header || header.dataset.init) return; header.dataset.init = '1';
  var section = header.parentElement;

  /* Sticky: hide when scrolling down past the header, reveal on scroll up (Ecomus "on_scroll_up"). */
  var mode = header.dataset.sticky || 'on_scroll_up';
  if (mode !== 'none') {
    var lastY = window.scrollY, ticking = false, h = header.offsetHeight;
    var onScroll = function () {
      var y = window.scrollY;
      section.classList.toggle('is-stuck', y > 2);
      if (mode === 'on_scroll_up') {
        if (y > lastY && y > h + 41) section.classList.add('is-hidden');
        else if (y < lastY - 2 || y <= h) section.classList.remove('is-hidden');
      }
      lastY = y; ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    window.addEventListener('resize', function () { h = header.offsetHeight; }, { passive: true });
  } else { section.classList.add('is-static'); }

  /* Dropdowns: hover via CSS; click/keyboard toggles for touch + a11y. */
  var items = header.querySelectorAll('.rs-nav__item.has-dropdown');
  items.forEach(function (li) {
    var btn = li.querySelector('.rs-nav__link');
    btn.addEventListener('click', function (e) {
      e.preventDefault(); var open = li.classList.toggle('is-open'); btn.setAttribute('aria-expanded', open);
      items.forEach(function (o) { if (o !== li) { o.classList.remove('is-open'); o.querySelector('.rs-nav__link').setAttribute('aria-expanded', 'false'); } });
    });
    li.addEventListener('mouseleave', function () { li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); });
  });
  function closeAll() { items.forEach(function (o) { o.classList.remove('is-open'); o.querySelector('.rs-nav__link').setAttribute('aria-expanded', 'false'); }); if (header.contains(document.activeElement)) document.activeElement.blur(); } /* R-16: aria reset + blur so :focus-within lets the panel hide */
  document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Mobile drawer */
  var drawer = document.getElementById('menu_mobile'); var burger = header.querySelector('.rs-header__burger');
  if (drawer && burger) {
    var open = function () { drawer.showModal(); document.documentElement.classList.add('rs-drawer-open'); if (window.rsScrollLock) window.rsScrollLock('menu', true); burger.setAttribute('aria-expanded', 'true'); };
    var close = function () { drawer.close(); };
    burger.addEventListener('click', open);
    drawer.querySelector('.rs-drawer__close').addEventListener('click', close);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); }); /* backdrop click */
    drawer.addEventListener('close', function () { document.documentElement.classList.remove('rs-drawer-open'); if (window.rsScrollLock) window.rsScrollLock('menu', false); burger.setAttribute('aria-expanded', 'false'); });
  }
}
initHeader(document.querySelector('.rs-header'));
/* Theme Editor re-renders the section: bind again on the new DOM (R-14). */
document.addEventListener('shopify:section:load', function (e) { initHeader(e.target && e.target.querySelector('.rs-header')); });
})();
